export default __webpack_public_path__ + "static/media/austin-wade-X6Uj51n5CE8-unsplash 1.26ec2f81.png";